var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificationBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.8,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_2",
    clipPath: "url(#clip0_8905_54547)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-0.48832 8.44749 10.6183)",
    stroke: "#151C2B",
    id: "svg_1",
    strokeWidth: 1.6,
    d: "m1.15222,15.76527c-0.20457,-0.1179 -0.33064,-0.336 -0.33064,-0.5721l0,-11.46521c0,-0.26286 0.15755,-0.50192 0.39964,-0.6043c5.58429,-2.36167 8.88495,-2.29798 14.46945,0.2561c0.2353,0.10761 0.3855,0.34544 0.3827,0.60413l-0.1224,11.21408c-0.0026,0.2335 -0.1283,0.4483 -0.3306,0.5649l-6.90656,3.9792c-0.20402,0.1175 -0.4552,0.1175 -0.65922,0l-6.90237,-3.9768z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-0.48832 8.45605 11.3741)",
    stroke: "null",
    id: "svg_2",
    fill: "#151C2B",
    d: "m15.72421,9.20122l-14.53632,0l0,4.3457l14.53632,0l0,-4.3457z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationBadge);
export default __webpack_public_path__ + "static/media/certification-badge.77cd4b918e1867eab3e2935fbede65eb.svg";
export { ForwardRef as ReactComponent };